import { createGlobalStyle } from 'styled-components'

export const GlobalStyleExtended = createGlobalStyle`
  html,
  body {
  background-color: ${({ theme }) => theme?.ColorThemeBackgroundPage};
  }
`
